export const UserStyles= 
{
   iconColor: { color: "white" },
   headingColor: { color: "#00BBBB" },
   padding: {padding: '20px'}
};